import { SearchOptions } from 'js/model/rainbow/browse-page/SearchOptions';
import { VenueListingSpecificationOutput } from 'js/model/rainbow/browse-page/VenueListingSpecificationOutput';
import { isPriceRangeFilterRenderableForRange } from '../FilterModal/PriceRangeFilter';

export const PRICE_RANGE_FILTER_EXPONENT = 1.9;

export const isPriceRangeFilterAvailable = ({
  minServicePrice,
  maxServicePrice,
}: SearchOptions): boolean =>
  minServicePrice !== undefined &&
  maxServicePrice !== undefined &&
  isPriceRangeFilterRenderableForRange(
    minServicePrice,
    maxServicePrice,
    PRICE_RANGE_FILTER_EXPONENT
  );

export const getPriceRangeLowerBound = (
  { minServicePrice }: SearchOptions,
  { price }: VenueListingSpecificationOutput
): number => price?.min ?? minServicePrice!;

export const getPriceRangeUpperBound = (
  { maxServicePrice }: SearchOptions,
  { price }: VenueListingSpecificationOutput
): number => price?.max ?? maxServicePrice!;

export const isPriceRangeFilterActive = (
  searchOptions: SearchOptions,
  specification: VenueListingSpecificationOutput
): boolean => {
  const lowerBound = getPriceRangeLowerBound(searchOptions, specification);
  const upperBound = getPriceRangeUpperBound(searchOptions, specification);

  return (
    lowerBound !== searchOptions.minServicePrice ||
    upperBound !== searchOptions.maxServicePrice
  );
};

export function findClosest(elements: number[], target: number): number {
  if (elements.length === 0 || elements.includes(target)) {
    return target;
  }

  const diffs = elements.map((element) => Math.abs(element - target));
  const minDiff = Math.min(...diffs);

  return elements[diffs.indexOf(minDiff)];
}
